<template>
<div class="chapter">
<div class="inner_page">
<div class="image_container">
<img alt="images" src="images/f000i-01.jpg"/>
<p class="caption"><em class="italic">A Pzkpfw IV ausf G, from Panzer-Regiment 22 of 21.Panzer-Division photographed at some time prior to the Normandy landings. Note the early muzzle brake, introduced with the 7.5cm L/43 gun, and the turret and hull Schürzen which are the first pattern and coated with Zimmerit. Another view of this tank is shown in the photograph on <span href="#/xhtml/07_Chapter02#page_10" title="Link target outside of Sample">page 10</span></em>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Fm01.vue?b37f061e